import { Component } from '@angular/core';
import { MatLegacyDialog as MatLgDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'upsc-termsandconditions',
  templateUrl: './termsandconditions.component.html',
  styleUrls: ['./termsandconditions.component.scss']
})
export class TermsandconditionsComponent {
  constructor(private dialogRef:MatDialogRef<TermsandconditionsComponent>){
 
}
  public close() {
    this.dialogRef.close('close');
  }
}
